$(function() {

  /* Wrap RTE Table */
  $(".rte table").each(function() {
    $(this).wrap("<div class='table__wrapper'></div>");
  });

  /* Begin: LPU x Manifold */
  $.urlParam = function(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
    return (results !== null) ? results[1] || 0 : false;
  }

  var REFERRER_1 = "https://www.sparkart.com/";
  var REFERRER_2 = "https://lpu-frontend-cloudflare.pages.dev/";
  var REFERRER_3 = "https://lpunderground.com/";
  var REFERRER_4 = "https://www.lpunderground.com/";
  var TOKEN = "xgOuDjRjN-T_7zfriORIB";

  if ($('body').hasClass('page-lpu-login')) {

    console.log("0: " + document.referrer);

    if (document.referrer === REFERRER_1 || document.referrer === REFERRER_2 || document.referrer === REFERRER_3 || document.referrer === REFERRER_4) {

      // window.location.href = window.location.href + '&referred=true';
      localStorage.setItem("referred", "true");
      console.log("1: " + document.referrer);
      console.log('referrer true');

      if (localStorage.getItem("visited") === "true") {

        console.log("4: visited true");

        if ($.urlParam('tier') != "0" && $.urlParam('tier') != "") {
          localStorage.setItem("lpuTier", $.urlParam('tier'));
          var uri = decodeURIComponent($.urlParam('lpstoreOriginalUrl')) + '?ls=' + TOKEN;
        } else {
          var uri = decodeURIComponent($.urlParam('lpstoreOriginalUrl'));
        }

        var shortUri = uri.replace('https://store.linkinpark.com', '');
        window.location = shortUri;

      }

      setTimeout(function() {
        window.location = window.location;
      }, 2000);

    } else if (document.referrer.indexOf('lpu-login') && localStorage.getItem("referred") === "true" && $.urlParam('token') === TOKEN) {

      console.log("2: " + document.referrer);

      if ($.urlParam('tier') === "0" || $.urlParam('tier') === "") {

        console.log("2a");

        localStorage.setItem("lpuTier", "0");
        localStorage.setItem("visited", "true");
        console.log('tier is not passport plus');
        var uri = decodeURIComponent($.urlParam('lpstoreOriginalUrl')) + '?error=upgrade';
        var shortUri = uri.replace('https://store.linkinpark.com', '');
        console.log(shortUri);
        window.location = shortUri;

      } else {

        console.log("2b");

        localStorage.setItem("lpuTier", $.urlParam('tier'));
        localStorage.setItem("visited", "true");
        console.log('tier ' + $.urlParam('tier'));
        var uri = decodeURIComponent($.urlParam('lpstoreOriginalUrl')) + '?ls=' + TOKEN;
        var shortUri = uri.replace('https://store.linkinpark.com', '');
        console.log(shortUri);
        window.location = shortUri;

      }

    } else {

      console.log("5: no referrer");
      window.location = "/";

    }

  }

  if ($.urlParam('ls')) {
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {
      var clean_uri = uri.substring(0, uri.indexOf("?"));
      window.history.replaceState({}, document.title, clean_uri);
    }
  }

  /* if( $('body').hasClass('collection-lpu') && $.urlParam('test') ){
    $('body').addClass('manifold-test');
  } */

  if ($('body').hasClass('template-product') && ($.urlParam('error') == 'upgrade' || localStorage.getItem("lpuTier") === "0" || localStorage.getItem("lpuTier") === "")) {
    $('body').addClass('lpu-upgrade');
  }
  /* End: LPU x Manifold */

});